import React from 'lib/react';
import Typography from 'commonComponents/typography';
import {
  EVGrid,
  EVRoofIcon,
  EVWallsIcon,
  EVWholeHomeIcon,
} from 'lib/components';

// #genai
export function getSubscriptionIconBySkuName(subscriptionSkuName, iconClassName) {
  const name = (subscriptionSkuName || '').toLowerCase();
  if (name.includes('full house') || name.includes('whole home')) {
    return <EVWholeHomeIcon className={iconClassName} />;
  }
  if (name.includes('walls') || name.includes('windows') || name.includes('doors')) {
    return <EVWallsIcon className={iconClassName} />;
  }
  if (name.includes('bid perfect') || name.includes('roof')) {
    return <EVRoofIcon className={iconClassName} />;
  }
  return <EVWholeHomeIcon className={iconClassName} />;
}

export function renderSubscriptionIconWithOne({
  subscriptionSkuName,
  iconClassName,
  containerClassName,
  badgeClassName,
  badgeTextClassName,
  isSubscriptionProduct = true,
}) {
  if (!isSubscriptionProduct) {
    return (
      <EVGrid className={containerClassName}>
        {getSubscriptionIconBySkuName(subscriptionSkuName, iconClassName)}
      </EVGrid>
    );
  }
  return (
    <EVGrid className={containerClassName}>
      {getSubscriptionIconBySkuName(subscriptionSkuName, iconClassName)}
      <EVGrid className={badgeClassName}>
        <Typography className={badgeTextClassName}>ONE</Typography>
      </EVGrid>
    </EVGrid>
  );
}
